import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { FactCheckResult } from "../components/FactCheckResult";
import { VerdictBadge } from "../components/VerdictBadge";
import { Card } from "../components/ui/card";
import { NewsletterSignup } from "../components/NewsletterSignup";
import { Sunrise } from "lucide-react";
import { motion } from "framer-motion";

export default function FactOfDay() {
    const [fod, setFod] = useState(null);
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get("/fact-of-day").then((r) => setFod(r.data)),
            api.get("/fact-of-day/history").then((r) => setHistory(r.data || [])),
        ]).finally(() => setLoading(false));
    }, []);

    return (
        <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16">
            <div className="mb-10 flex flex-wrap items-end justify-between gap-6">
                <div>
                    <div className="text-xs uppercase tracking-widest text-primary mb-3 flex items-center gap-2">
                        <Sunrise className="h-3 w-3" /> Fact of the Day
                    </div>
                    <h1 className="font-display text-4xl md:text-5xl text-accent tracking-tight leading-tight">
                        {new Date().toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" })}
                    </h1>
                    <p className="text-muted-foreground mt-3 max-w-xl">
                        One viral claim, rigorously verified — refreshed every day.
                    </p>
                </div>
            </div>

            {loading ? (
                <p className="text-muted-foreground text-sm">Loading today&apos;s fact…</p>
            ) : !fod ? (
                <Card className="card-surface p-10 rounded-2xl text-center text-muted-foreground">
                    Today&apos;s fact is being prepared. Check back in a moment.
                </Card>
            ) : (
                <div data-testid="fact-of-day-detail">
                    <FactCheckResult result={fod} />
                </div>
            )}

            <div className="mt-14">
                <NewsletterSignup source="fact-of-day" />
            </div>

            {history.length > 1 && (
                <section className="mt-16">
                    <h2 className="font-display text-2xl text-accent mb-6">Recent Facts of the Day</h2>
                    <div className="grid md:grid-cols-2 gap-4" data-testid="fact-of-day-history">
                        {history.slice(1).map((tc, i) => (
                            <motion.div
                                key={tc.check_id}
                                initial={{ opacity: 0, y: 12 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.35, delay: i * 0.03 }}
                            >
                                <Link
                                    to={`/check/${tc.check_id}`}
                                    className="card-surface rounded-2xl p-6 block hover:-translate-y-0.5 transition-transform"
                                    data-testid={`fact-of-day-history-item-${i}`}
                                >
                                    <VerdictBadge verdict={tc.verdict} confidence={tc.confidence} size="sm" />
                                    <p className="mt-4 text-accent font-medium leading-snug line-clamp-3">
                                        &ldquo;{tc.claim}&rdquo;
                                    </p>
                                    <p className="mt-3 text-xs text-muted-foreground">
                                        {new Date(tc.created_at).toLocaleDateString()}
                                    </p>
                                </Link>
                            </motion.div>
                        ))}
                    </div>
                </section>
            )}
        </div>
    );
}
